import { useEffect } from 'react';
import { filtersSubject } from '@context/ProjectFilters/FiltersSubject';
import { skip } from 'rxjs';

const useCloseMenuOnFilters = ({ closeMenu }: { closeMenu: () => void }) => {
  useEffect(() => {
    const subscription = filtersSubject
      .pipe(skip(1))
      .subscribe(() => closeMenu());

    return () => subscription.unsubscribe();
  }, [closeMenu]);
};

export default useCloseMenuOnFilters;
